<template>
	<div>
		<!-- <test right>
			<a rel="noreferrer" id="home" href="#">
				<span>Home</span>
			</a>
		</test> -->
		<div class="mobile-menu-container">
			<SlideMobile :right="right"class="mobile-menu" width="320">
				<slot name="menu"></slot>
			</SlideMobile>
			<a rel="noreferrer" href="/">
				<figure class="image is-64x64 image-contain mobile-logo">
					<img src="/front/img/logo.svg" :alt="this.locale == 'en' ? 'Tam' : 'تم'">
				</figure>
			</a>
			<slot name="lang"></slot>
		</div>
	</div>

</template>

<script>
	import { Slide } from 'vue-burger-menu'
	export default {
		name: 'MobileHeader',
		props:{
			sitelocale:{
				required:true,
				type:String
			},
		},
		data(){
			return {
				right: null
			}
		},
		created(){
			if(this.sitelocale == 'ar'){
				this.right = true;
			}else{
				this.right = false;
			}
		},
		components: {
			SlideMobile : Slide
		}

	};
</script>
<style lang="scss">

</style>
